import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { Modal } from "react-bootstrap";

import { getLoggedProfile } from "../../actions/sessionAct";

import {
	getTripDetail,
	uploadInsurancePhoto,
	removeInsurancePhoto,
	activeInsurance,
	getActiveInsurance,
	getTripLocationHistory,
	getCarLocationHistory,
	getPhoneInsurance,
	getCarCalendar,
} from "../../model/car";

import { commonErr } from "../common/errors";
import { MessageBox } from "../common/messagebox";
import {
	formatPrice,
	formatTitleInUrl,
	getCountDownTime,
	convertToDateTimeText,
	convertToDateTimeObj,
	wdType,
	stypes,
	moment,
	CarTransmission,
	renderNumberGreaterThan100,
} from "../common/common";
import { LoadingPage } from "../common/loading";

import { mapSdk } from "../../model/base";
import { initMap } from "../common/wdfunction";

import Header from "../components/header";
import Footer from "../components/footer";
import Session from "../common/session";

import Login from "../login/login";
import SignUp from "../login/signup";
import PriceSummary from "../car/components/pricesummary";
import CancelPolicy from "../car/components/cancelpolicy";
import CancelTrip from "./canceltrip";
import CancelTripOwner from "./canceltripowner";
import ApproveTripOwner from "./approvetripowner";
import RejectTripOwner from "./rejecttripowner";
import PickupTrip from "./pickuptrip";
import ReturnTrip from "./returntrip";
import BeforeTrip from "./components/beforetrip";
import ReviewTripTraveler from "./reviewtriptraveler";
import DriverLicense from "../account/driverlicense";
import InsuranceTrip from "./components/insurancetrip";
import StatusTrip from "./components/statustrip";

import {
	IcArrowCancelPolicy,
	IcClockL,
	IcCalendarBlack,
	IcLimitKM,
	IcStarRating,
	IcTotalTrip,
	IcPhone,
	IcInformation,
	IcStartLocGreen,
	IcCheckGreen,
	IcCloseRed,
	IcLocationGreen,
	IcLocationS,
	IcEndLocWD,
	IcEndLocGreen,
	InsuranceBlack,
	InsuranceGreen,
	IcStartLocWD,
	IcCheckWhite,
	IcCheckL,
	IcCarL,
	IcCancelCarL,
} from "../common/svg";
import { Papers, Mortgates, Policy, Surcharge } from "../car/components/infocar";
// import TripPhoto from "./tripphoto"
// import ImageUpload from "../common/imageupload"

import avatar_default from "../../static/images/avatar_default.png";

import bg_ins from "../../static/images/tutorial/banner-top.png";
import global_care from "../../static/images/insurance/global-care.png";
import mic from "../../static/images/insurance/mic.png";
import pjico from "../../static/images/insurance/pjico.png";
import pvi from "../../static/images/insurance/pvi.png";
import vni from "../../static/images/insurance/vni.png";

class CarMapLocation extends React.Component {
	initMap = (refs, lat, lng) => {
		if (mapSdk != 0) {
			setTimeout(() => {
				initMap(true, this.refs, [{ lat: lat, lng: lng }]);
			}, 1000);
			return;
		}
	};

	componentDidMount() {
		const { location } = this.props;
		if (this.props.location) {
			setTimeout(() => {
				this.initMap(this.refs, location.lat, location.lon);
			}, 100);
		}
	}

	render() {
		return <div ref="map" id="map" className="wrap-map" />;
	}
}

class GPSMap extends React.Component {
	constructor() {
		super();
		this.state = {
			isValidTripGPS: true,
		};
	}

	componentDidMount() {
		const { tripId, tripStatus, carId } = this.props;
		getTripLocationHistory(tripId).then((tripLocationHistoryResp) => {
			if (tripLocationHistoryResp.data.data && tripLocationHistoryResp.data.data.loc.lat.length > 0) {
				let tripLocationArray = [];
				for (let i = 0; i < tripLocationHistoryResp.data.data.loc.lat.length; i++) {
					tripLocationArray.push({
						lat: tripLocationHistoryResp.data.data.loc.lat[i],
						lng: tripLocationHistoryResp.data.data.loc.lon[i],
					});
				}
				if (tripStatus === 25) {
					this.initMap(this.refs, tripLocationArray);
				}
				// === 5
				else {
					this.initMap(this.refs, tripLocationArray);
					// realtime append point
					this.intervalReference = setInterval(() => {
						getCarLocationHistory(carId, 1).then((carLocationHistoryResp) => {
							if (carLocationHistoryResp.data.data && carLocationHistoryResp.data.data.loc.lat.length > 0) {
								const newLocation = {
									lat: carLocationHistoryResp.data.data.loc.lat[0],
									lng: carLocationHistoryResp.data.data.loc.lon[0],
								};
								const lastLocation = {
									lat: tripLocationArray[tripLocationArray.length - 1].lat,
									lng: tripLocationArray[tripLocationArray.length - 1].lng,
								};
								// set car last point to gps point
								this.lastMarker.setMap(null);
								this.setMarker(this.map, lastLocation);
								// set new point to car last point
								this.lastMarker = this.setMarker(this.map, newLocation, lastLocation);
								// push new location to current location array
								tripLocationArray.push(newLocation);
							}
						});
					}, 5000);
				}
			} else {
				this.setState({
					isValidTripGPS: false,
				});
			}
		});
	}
	componentWillUnmount() {
		clearInterval(this.intervalReference);
	}

	initMap(wdOneWay, refs, tripLocationArray) {
		if (mapSdk != 0) {
			setTimeout(() => {
				initMap(wdOneWay, this.refs, tripLocationArray);
			}, 1000);
			return;
		}
		// const map = this.map = new window.google.maps.Map(refs.map, {
		// 	center: {
		// 		lat: tripLocationArray[tripLocationArray.length - 1].lat,
		// 		lng: tripLocationArray[tripLocationArray.length - 1].lng
		// 	},
		// 	zoom: 13,
		// 	mapTypeControl: false,
		// 	scrollwheel: false,
		// 	clickableIcons: false,
		// 	streetViewControl: false,
		// 	zoomControl: true,
		// 	zoomControlOptions: {
		// 		position: window.google.maps.ControlPosition.RIGHT_BOTTOM
		// 	}
		// })
		// polyline
		// var tripPath = new window.google.maps.Polyline({
		// 	path: tripLocationArray,
		// 	geodesic: true,
		// 	strokeColor: '#008000',
		// 	strokeOpacity: 1.0,
		// 	strokeWeight: 2
		// });
		// tripPath.setMap(map);

		// set marker to all point current
		// for (let tripLocation of tripLocationArray) {
		// 	this.setMarker(map, {
		// 		lat: tripLocation.lat,
		// 		lng: tripLocation.lng
		// 	})
		// }
		// // set first marker (for bounds)
		// this.firstMarker = this.setMarker(map, {
		// 	lat: tripLocationArray[0].lat,
		// 	lng: tripLocationArray[0].lng
		// })
		// set car last marker
		// this.lastMarker = this.setMarker(map, {
		// 	lat: tripLocationArray[tripLocationArray.length - 1].lat,
		// 	lng: tripLocationArray[tripLocationArray.length - 1].lng
		// }, {
		// 	lat: tripLocationArray[tripLocationArray.length - 2].lat,
		// 	lng: tripLocationArray[tripLocationArray.length - 2].lng
		// })
		// // bounds
		// var bounds = new window.google.maps.LatLngBounds();
		// bounds.extend(this.firstMarker.position)
		// bounds.extend(this.lastMarker.position)
		// map.fitBounds(bounds);
	}

	setMarker(map, location, carMarkerPrevLocation) {
		var marker = new window.google.maps.Marker({
			position: location,
			title: "",
			icon: carMarkerPrevLocation
				? this.buildIcon(location.lat, location.lng, carMarkerPrevLocation.lat, carMarkerPrevLocation.lng)
				: "https://n1-cstg.mioto.vn/m/circle.png",
		});
		marker.setMap(map);
		return marker;
	}

	buildIcon(lat, lng, preLat, preLng) {
		const pre = new window.google.maps.LatLng(preLat, preLng);
		const cur = new window.google.maps.LatLng(lat, lng);
		var rotation = 0;
		if (preLat && preLng) {
			rotation = window.google.maps.geometry.spherical.computeHeading(pre, cur) - 90;
		}
		var scale = 0.5;
		return {
			path: "M63.656,43.791c-0.695-4.486-1.998-7.645-3.874-9.387c-1.422-1.271-3.185-0.922-3.22-0.913 c-0.375,0.005-37.69,0.501-40.094,0.572C10.641,34.235,7.685,39.597,7.685,50c0,10.402,2.956,15.765,8.784,15.937   c2.403,0.07,39.719,0.565,40.054,0.565c0.026,0.006,0.275,0.056,0.651,0.056c0.659,0,1.704-0.152,2.61-0.966   c1.874-1.738,3.177-4.896,3.872-9.384c0.512-3.311,0.486-6.156,0.485-6.208C64.143,49.948,64.168,47.103,63.656,43.791z    M16.195,50.755c-0.729,0-1.321-0.338-1.321-0.755s0.592-0.756,1.321-0.756s1.322,0.339,1.322,0.756S16.925,50.755,16.195,50.755z M94.822,33.357l-0.387-0.482c-2.192-2.729-3.924-4.886-9.569-4.886H64.785c-0.266,0-1.062,0.01-1.502,0.016   c0.591-1.85,0.316-3.496-0.755-4.444c-0.933-0.825-2.263-0.925-3.558-0.265c-0.292,0.148-0.242,0.663,0.113,2.63   c0.135,0.743,0.314,1.736,0.291,2.063c-3.052,0-7.566,0.033-12.343,0.066c-11.478,0.082-25.762,0.184-30.114-0.066   c-5.299-0.305-8.856,0.534-10.885,2.563C4.381,32.205,1.61,36.926,1.61,50c0,13.072,2.771,17.795,4.423,19.447   c2.029,2.028,5.589,2.868,10.885,2.562c4.353-0.25,18.637-0.148,30.114-0.067c4.776,0.035,9.291,0.067,12.343,0.067   c0.023,0.326-0.156,1.321-0.291,2.064c-0.355,1.966-0.405,2.481-0.113,2.629c0.566,0.29,1.144,0.434,1.688,0.434   c0.697,0,1.347-0.235,1.869-0.697c1.071-0.949,1.346-2.595,0.755-4.445c0.44,0.007,1.236,0.016,1.502,0.016h20.081   c5.646,0,7.377-2.156,9.569-4.886l0.387-0.481c3.584-4.425,3.766-14.64,3.766-16.643S98.406,37.782,94.822,33.357z M89.902,30.071   c0,0,1.478,0.938,2.575,2.312s1.927,2.88,1.927,2.88c-1.225,0.997-3.063,0.884-4.465-0.841   C88.537,32.697,88.678,31.066,89.902,30.071z M96.228,41.042c0.042,0.272,0.427,3.491,0.439,3.662   c-0.019-0.205-12.272-2.258-17.295-2.876c0.011,0.078-0.429-2.706-0.847-4.127C78.525,37.701,90.791,39.231,96.228,41.042z    M75.119,66.329c-1.944,3.381-5.636,3.466-8.604,3.532l-0.225,0.005c-0.4,0.01-0.965,0.014-1.663,0.014   c-4.574,0-14.829-0.191-21.433-0.442c-7.387-0.281-24.802-0.791-28.287-0.714c-3.361,0.07-5.387,0.111-7.834-3.818   C4.681,61.06,3.897,52.513,3.897,50s0.783-11.06,3.177-14.906c2.447-3.93,4.477-3.887,7.834-3.817   c3.48,0.072,20.9-0.434,28.287-0.715c7.609-0.289,20.064-0.499,23.096-0.428l0.225,0.004c2.968,0.067,6.659,0.15,8.604,3.533   c2.12,3.692,3.387,9.797,3.387,16.329C78.506,56.531,77.239,62.636,75.119,66.329z M92.478,67.616   c-1.098,1.374-2.575,2.312-2.575,2.312c-1.225-0.996-1.365-2.625,0.037-4.351c1.401-1.727,3.24-1.838,4.465-0.843   C94.404,64.734,93.575,66.241,92.478,67.616z M96.228,58.956c-5.437,1.812-17.702,3.342-17.702,3.342   c0.418-1.42,0.857-4.205,0.847-4.127c5.022-0.619,17.276-2.67,17.295-2.875C96.654,55.466,96.27,58.686,96.228,58.956z",
			fillColor: "#000",
			fillOpacity: 1,
			strokeWeight: 0,
			scale: scale,
			anchor: new window.google.maps.Point(0, 39),
			rotation: rotation,
		};
	}

	render() {
		const { isValidTripGPS } = this.state;
		return (
			<div>{isValidTripGPS ? <div ref="map" id="map" className="wrap-map" /> : "Xe chưa được tích hợp Mioto GPS."}</div>
		);
	}
}

// class TripPhotoSlider extends React.Component {
// 	constructor(props) {
// 		super(props);

// 		this.state = {
// 			frInsPhoto: this.props.frInsPhoto,
// 			baInsPhoto: this.props.baInsPhoto,
// 			leInsPhoto: this.props.leInsPhoto,
// 			riInsPhoto: this.props.riInsPhoto,
// 			trip: this.props.trip

// 		}
// 		this.isEnabledUploadIns = this.isEnabledUploadIns
// 	}
// 	componentDidMount() {
// 		this.swiper = new window.Swiper(this.refs.swiperTripPhoto, {
// 			slidesPerView: 4,
// 			spaceBetween: 24,
// 			threshold: 15,
// 			speed: 500,
// 			loop: false,
// 			slidesOffsetBefore: 0,
// 			slidesOffsetAfter: 0,
// 			paginationClickable: true,
// 			breakpoints: {
// 				992: {
// 					slidesPerView: 3.2,

// 				},
// 				768: {
// 					slidesPerView: 2.4,

// 				},
// 				480: {
// 					slidesPerView: 1.5,

// 				}
// 			}
// 		})
// 	}

// 	componentWillReceiveProps(props) {
// 		this.setState({
// 			frInsPhoto: props.frInsPhoto,
// 			baInsPhoto: props.baInsPhoto,
// 			leInsPhoto: props.leInsPhoto,
// 			riInsPhoto: props.riInsPhoto,

// 		})
// 	}
// 	isEnabledUploadIns() {
// 		return moment().valueOf() + this.state.trip.insUpThr >= this.state.trip.tripDateFrom
// 	}

// 	render() {

// 		return <div ref={"swiperTripPhoto"} className="swiper swiper-trip-photo">
// 			    <div className="swiper-wrapper box-photo__wrap">
//                     <div className="box-item swiper-slide">
// 						<a onClick={this.isEnabledUploadIns() ? this.props.showTripPhoto : this.props.showMessageUpload }>
// 							<div className={`fix-img ${this.state.frInsPhoto.photos && this.state.frInsPhoto.photos.length > 0 ? "" : "add-box"}`}>
// 								<img src={this.state.frInsPhoto ? (this.state.frInsPhoto.photos && this.state.frInsPhoto.photos.length > 0 ? this.state.frInsPhoto.photos[(this.state.frInsPhoto.photos.length - 1)].url : this.state.frInsPhoto.tip) : ""} />
// 								{!this.state.frInsPhoto.photos && <div className="add-photo"><i className="ic ic-dark-plus"></i></div>}
// 							</div>
// 						</a>
// 					</div>
//                     <div className="box-item swiper-slide">
// 						<a onClick={this.isEnabledUploadIns() ? this.props.showTripPhoto : this.props.showMessageUpload}>
// 						<div className={`fix-img ${this.state.baInsPhoto.photos && this.state.baInsPhoto.photos.length > 0 ? "" : "add-box"}`}>
// 							<img src={this.state.baInsPhoto ? (this.state.baInsPhoto.photos && this.state.baInsPhoto.photos.length > 0 ? this.state.baInsPhoto.photos[(this.state.baInsPhoto.photos.length - 1)].url : this.state.baInsPhoto.tip) : ""} />
// 							{!this.state.baInsPhoto.photos && <div className="add-photo"><i className="ic ic-dark-plus"></i></div>}
// 						</div>
// 						</a>
// 					</div>
//                     <div className="box-item swiper-slide">
// 						<a onClick={this.isEnabledUploadIns() ? this.props.showTripPhoto : this.props.showMessageUpload}>
// 						<div className={`fix-img ${this.state.leInsPhoto.photos && this.state.leInsPhoto.photos.length > 0 ? "" : "add-box"}`}>
// 							<img src={this.state.leInsPhoto ? (this.state.leInsPhoto.photos && this.state.leInsPhoto.photos.length > 0 ? this.state.leInsPhoto.photos[(this.state.leInsPhoto.photos.length - 1)].url : this.state.leInsPhoto.tip) : ""} />
// 							{!this.state.leInsPhoto.photos && <div className="add-photo"><i className="ic ic-dark-plus"></i></div>}
// 						</div>
// 						</a>
// 					</div>
//           <div className="box-item swiper-slide">
// 						<a onClick={this.isEnabledUploadIns() ? this.props.showTripPhoto : this.props.showMessageUpload}>
// 						<div className={`fix-img ${this.state.riInsPhoto.photos && this.state.riInsPhoto.photos.length > 0 ? "" : "add-box"}`}>
// 							<img src={this.state.riInsPhoto ? (this.state.riInsPhoto.photos && this.state.riInsPhoto.photos.length > 0 ? this.state.riInsPhoto.photos[(this.state.riInsPhoto.photos.length - 1)].url : this.state.riInsPhoto.tip) : ""} />
// 							{!this.state.riInsPhoto.photos && <div className="add-photo"><i className="ic ic-dark-plus"></i></div>}
// 						</div>
// 						</a>
// 					</div>
// 				</div>
// 			</div>

// 	}
// }

class TripDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			specialDays: [],
			cancelPolicy: 0,
			showLoginForm: false,
			showCancelForm: false,
			showApproveForm: false,
			showRejectForm: false,
			showPickupForm: false,
			showReturnForm: false,
			showCancelOwnerForm: false,
			showTripPhoto: false,
			showMessageUpload: false,
			showInsuranceForm: false,
			showMsgCert: false,
			showDriverLicense: false,
			isShowTravelerReviewForm: false,
			err: commonErr.INNIT,
			errMsg: "",
			car: null,
			trip: null,
			profiles: null,
			paymentUrl: "",
			certInfo: null,
			frInsPhoto: {
				err: commonErr.INNIT,
			},
			baInsPhoto: {
				err: commonErr.INNIT,
			},
			leInsPhoto: {
				err: commonErr.INNIT,
			},
			riInsPhoto: {
				err: commonErr.INNIT,
			},
			directionsService: null,
			directionsRenderer: null,
			markerArr: [],
		};

		this.map = React.createRef();
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		const tripId = this.props.match.params.tripId;
		this.getTrip(tripId);
		this.getPhoneInsurance();
	}

	getTrip = (tripId) => {
		getTripDetail(tripId).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				// var frInsPhoto;
				// var baInsPhoto;
				// var leInsPhoto;
				// var riInsPhoto;
				// var self = this;
				// if(resp.data.data.trip.insPhotos){
				//     frInsPhoto = resp.data.data.trip.insPhotos.filter(ins => {
				//         return ins.id === "fr"
				//     })[0];

				//     baInsPhoto = resp.data.data.trip.insPhotos.filter(ins => {
				//             return ins.id === "ba"
				//     })[0];

				//     leInsPhoto = resp.data.data.trip.insPhotos.filter(ins => {
				//             return ins.id === "le"
				//     })[0];

				//     riInsPhoto = resp.data.data.trip.insPhotos.filter(ins => {
				//             return ins.id === "ri"
				//     })[0];
				//     self.setState({
				//         frInsPhoto: {
				//             ...self.state.frInsPhoto,
				//             photos: frInsPhoto.photos,
				//             tip: frInsPhoto.tip
				//         },
				//         baInsPhoto: {
				//             ...self.state.baInsPhoto,
				//             photos: baInsPhoto.photos,
				//             tip: baInsPhoto.tip
				//         },
				//         leInsPhoto: {
				//             ...self.state.leInsPhoto,
				//             photos: leInsPhoto.photos,
				//             tip: leInsPhoto.tip
				//         },
				//         riInsPhoto: {
				//             ...self.state.riInsPhoto,
				//             photos: riInsPhoto.photos,
				//             tip: riInsPhoto.tip
				//         },
				//     })
				// }
				this.setState({
					err: resp.data.error,
					car: resp.data.data.car,
					trip: resp.data.data.trip,
					profiles: resp.data.data.profiles,
				});

				getCarCalendar(
					resp.data.data.trip.carId,
					resp.data.data.trip.tripDateFrom,
					resp.data.data.trip.tripDateTo
				).then((response) => {
					if (response.data.error >= commonErr.SUCCESS && response.data.data) {
						this.setState({
							specialDays: response.data.data.specialDays,
						});
					}
				});

				if (resp.data.data.trip.timeExpired > 0) {
					var countDownDate = resp.data.data.trip.timeExpired;

					// Update the count down every 1 second
					var x = setInterval(() => {
						// Get todays date and time
						var timeRemain = getCountDownTime(countDownDate);

						// Display the result in the element with id="demo"
						this.setState({
							countdown: convertToDateTimeText(timeRemain),
						});

						// If the count down is finished, write some text
						if (timeRemain < 0) {
							clearInterval(x);
							this.setState({
								countdown: convertToDateTimeText(timeRemain),
							});
						}
					}, 1000);
				} else {
					this.setState({
						countdown: "",
					});
				}
				// wd
				if (resp.data.data.trip.serviceType === 2) {
					let locationArray = [];
					let { routes } = resp.data.data.trip.wd.routing;
					for (let i = 0; i < routes.length; i++) {
						locationArray.push({ lat: routes[i].lat, lng: routes[i].lon });
					}

					setTimeout(() => {
						initMap(resp.data.data.trip.wd.wdType === wdType.WDT_ONEWAY, this.map, locationArray, false, "", stypes.WD);
					}, 1000);
				}

				//cancel-policy
				const oneHourToMilliseconds = 3600000;
				const sevenDaysToMilliseconds = 604800000;
				const timeNow = moment().valueOf();
				const timeAfterDeposited = timeNow - resp.data.data.trip.timeDeposited;
				if (timeAfterDeposited <= oneHourToMilliseconds) {
					this.setState({
						cancelPolicy: 1,
					});
				} else if (resp.data.data.trip.tripDateFrom - timeNow > sevenDaysToMilliseconds) {
					this.setState({
						cancelPolicy: 2,
					});
				} else {
					this.setState({
						cancelPolicy: 3,
					});
				}
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	getActiveInsurance = (tripId, certNo) => {
		getActiveInsurance(tripId, certNo).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					certInfo: resp.data.data,
				});
			} else {
				this.setState({
					certErr: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	getPhoneInsurance = () => {
		getPhoneInsurance().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					phoneInsMic: resp.data.data.zones,
					phoneInsPjico: resp.data.data.zonesPjico,
					phoneInsPVI: resp.data.data.zonesPVI,
					phoneInsVNI: resp.data.data.zonesVNI,
				});
			}
		});
	};

	showLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	cancelTrip = () => {
		this.showCancelForm();
	};

	showCancelForm = () => {
		this.setState({
			showCancelForm: true,
		});
	};

	closeCancelForm = () => {
		this.setState({
			showCancelForm: false,
		});
	};

	showApproveForm = () => {
		this.setState({
			showApproveForm: true,
		});
	};

	closeApproveForm = () => {
		this.setState({
			showApproveForm: false,
		});
	};

	showRejectForm = () => {
		this.setState({
			showRejectForm: true,
		});
	};

	closeRejectForm = () => {
		this.setState({
			showRejectForm: false,
		});
	};

	showPickupForm = () => {
		this.setState({
			showPickupForm: true,
		});
	};

	closePickupForm = () => {
		this.setState({
			showPickupForm: false,
		});
	};

	showReturnForm = () => {
		this.setState({
			showReturnForm: true,
		});
	};

	closeReturnForm = () => {
		this.setState({
			showReturnForm: false,
		});
	};

	showCancelOwnerForm = () => {
		this.setState({
			showCancelOwnerForm: true,
		});
	};

	closeCancelOwnerForm = () => {
		this.setState({
			showCancelOwnerForm: false,
		});
	};

	showTravelerReviewForm = () => {
		this.setState({
			isShowTravelerReviewForm: true,
		});
	};

	closeTravelerReviewForm = () => {
		this.setState({
			isShowTravelerReviewForm: false,
		});
	};

	// showTripPhoto() {
	// 	this.setState({
	// 		showTripPhoto: true
	// 	});
	// }

	// closeTripPhoto() {
	// 	this.setState({
	// 		showTripPhoto: false
	// 	});
	// 	const tripId = this.props.match.params.tripId;
	// 	this.getTrip(tripId);
	// 	// this.showActiveInsMsg()
	// }
	showInsuranceForm = (tripId, certNo) => {
		this.setState({
			showInsuranceForm: true,
		});
		this.getActiveInsurance(tripId, certNo);
	};

	closeInsuranceForm = () => {
		this.setState({
			showInsuranceForm: false,
		});
	};

	travelerReview = () => {
		this.showTravelerReviewForm();
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	onCertDetailBtn = (certInfo) => {
		if (certInfo.certUrl) {
			window.open(certInfo.certUrl, "_blank");
		} else {
			this.setState({
				showMsgCert: true,
			});
		}
	};
	showMsgCert = () => {
		this.setState({
			showMsgCert: true,
		});
	};
	closeMsgCert = () => {
		this.setState({
			showMsgCert: false,
		});
	};

	reRenderTripPhoto = () => {
		this.closeTripPhoto();
		this.showTripPhoto();
	};

	handleFrInsFileInputChange = (photos) => {
		this.setState({
			frInsPhoto: {
				...this.state.frInsPhoto,
				err: commonErr.LOADING,
			},
		});
		uploadInsurancePhoto(this.state.trip.id, "fr", photos[0]).then((resp) => {
			if (resp.data.error !== commonErr.SUCCESS) {
				this.setState({
					actErr: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				var photos = [];
				if (this.state.frInsPhoto.photos) {
					photos = photos.concat(this.state.frInsPhoto.photos);
				}
				if (resp.data.data && resp.data.data.id) {
					photos.push(resp.data.data);
				}
				this.setState({
					frInsPhoto: {
						...this.state.frInsPhoto,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						photos: photos,
					},
				});

				if (this.state.showTripPhoto) {
					this.reRenderTripPhoto();
				}
			}
		});
	};

	handleBaInsFileInputChange = (photos) => {
		this.setState({
			baInsPhoto: {
				...this.state.baInsPhoto,
				err: commonErr.LOADING,
			},
		});
		uploadInsurancePhoto(this.state.trip.id, "ba", photos[0]).then((resp) => {
			if (resp.data.error !== commonErr.SUCCESS) {
				this.setState({
					actErr: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				var photos = [];
				if (this.state.baInsPhoto.photos) {
					photos = photos.concat(this.state.baInsPhoto.photos);
				}
				if (resp.data.data && resp.data.data.id) {
					photos.push(resp.data.data);
				}
				this.setState({
					baInsPhoto: {
						...this.state.baInsPhoto,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						photos: photos,
					},
				});
				if (this.state.showTripPhoto) {
					this.reRenderTripPhoto();
				}
			}
		});
	};
	handleLeInsFileInputChange = (photos) => {
		this.setState({
			leInsPhoto: {
				...this.state.leInsPhoto,
				err: commonErr.LOADING,
			},
		});
		uploadInsurancePhoto(this.state.trip.id, "le", photos[0]).then((resp) => {
			if (resp.data.error !== commonErr.SUCCESS) {
				this.setState({
					actErr: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				var photos = [];
				if (this.state.leInsPhoto.photos) {
					photos = photos.concat(this.state.leInsPhoto.photos);
				}
				if (resp.data.data && resp.data.data.id) {
					photos.push(resp.data.data);
				}
				this.setState({
					leInsPhoto: {
						...this.state.leInsPhoto,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						photos: photos,
					},
				});
				if (this.state.showTripPhoto) {
					this.reRenderTripPhoto();
				}
			}
		});
	};
	handleRiInsFileInputChange = (photos) => {
		this.setState({
			riInsPhoto: {
				...this.state.riInsPhoto,
				err: commonErr.LOADING,
			},
		});
		uploadInsurancePhoto(this.state.trip.id, "ri", photos[0]).then((resp) => {
			var photos = [];
			if (resp.data.error !== commonErr.SUCCESS) {
				this.setState({
					actErr: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			} else {
				if (this.state.riInsPhoto.photos) {
					photos = photos.concat(this.state.riInsPhoto.photos);
				}
				if (resp.data.data && resp.data.data.id) {
					photos.push(resp.data.data);
				}
				this.setState({
					riInsPhoto: {
						...this.state.riInsPhoto,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						photos: photos,
					},
				});
				if (this.state.showTripPhoto) {
					this.reRenderTripPhoto();
				}
			}
		});
	};

	removeInsurancePhoto = (imageId, photoId) => {
		removeInsurancePhoto(this.state.trip.id, imageId, photoId).then((resp) => {
			if (resp.data.error == commonErr.SUCCESS) {
				var photos = [];
				if (imageId === "fr") {
					if (this.state.frInsPhoto.photos) {
						photos = photos.concat(this.state.frInsPhoto.photos);
					}
					photos = photos.filter((p) => {
						return p.id !== photoId;
					});
					this.setState({
						frInsPhoto: {
							...this.state.frInsPhoto,
							photos: photos,
						},
					});
					return;
				} else if (imageId === "ba") {
					if (this.state.baInsPhoto.photos) {
						photos = photos.concat(this.state.baInsPhoto.photos);
					}
					photos = photos.filter((p) => {
						return p.id !== photoId;
					});
					this.setState({
						baInsPhoto: {
							...this.state.baInsPhoto,
							photos: photos,
						},
					});
					return;
				} else if (imageId === "le") {
					if (this.state.leInsPhoto.photos) {
						photos = photos.concat(this.state.leInsPhoto.photos);
					}
					photos = photos.filter((p) => {
						return p.id !== photoId;
					});
					this.setState({
						leInsPhoto: {
							...this.state.leInsPhoto,
							photos: photos,
						},
					});
					return;
				} else if (imageId === "ri") {
					if (this.state.riInsPhoto.photos) {
						photos = photos.concat(this.state.riInsPhoto.photos);
					}
					photos = photos.filter((p) => {
						return p.id !== photoId;
					});
					this.setState({
						riInsPhoto: {
							...this.state.riInsPhoto,
							photos: photos,
						},
					});
					return;
				}
			} else {
				this.setState({
					actErr: resp.data.err,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	activeInsurance = () => {
		activeInsurance(this.state.trip.id).then((resp) => {
			this.setState({
				actErr: resp.data.error,
				errMsg: resp.data.errorMessage,
			});
		});
	};

	showMessageUpload = () => {
		this.setState({
			showMessageUpload: true,
		});
	};
	closeMessageUpload = () => {
		this.setState({
			showMessageUpload: false,
		});
	};

	hideMessageBox = () => {
		this.setState({
			errMsg: "",
		});
		this.getTrip(this.props.match.params.tripId);
	};

	isEnabledActIns = () => {
		return moment().valueOf() + this.state.trip.insUpThr >= this.state.trip.tripDateFrom;
	};

	initMap(wdOneWay, refs, locAddress) {
		if (mapSdk != 0) {
			setTimeout(() => {
				initMap(wdOneWay, this.refs, locAddress);
			}, 1000);
			return;
		}
		// var directionsService = new window.google.maps.DirectionsService;
		// var directionsRenderer = new window.google.maps.DirectionsRenderer({
		// 	polylineOptions: {
		// 		strokeColor: "#00a550",
		// 		strokeWeight: 3
		// 	},
		// 	suppressMarkers: true,

		// });
		// var directionsRendererBackOW = new window.google.maps.DirectionsRenderer({
		// 	polylineOptions: {
		// 		strokeColor: "#000",
		// 		strokeWeight: 3
		// 	},
		// 	suppressMarkers: true,

		// });
		// const map = this.map = new window.google.maps.Map(refs.map, {
		// 	center: {
		// 		lat: 10.8,
		// 		lng: 106.660172
		// 	},
		// 	zoom: 13,
		// 	mapTypeControl: false,
		// 	scrollwheel: false,
		// 	clickableIcons: false,
		// 	streetViewControl: false,
		// 	zoomControl: true,
		// 	zoomControlOptions: {
		// 		position: window.google.maps.ControlPosition.RIGHT_BOTTOM
		// 	}
		// })

		// directionsRenderer.setMap(map);
		// directionsRendererBackOW.setMap(map);

		// this.calculateAndDisplayRoute(wdOneWay, directionsService, directionsRenderer, directionsRendererBackOW, locAddress, map)
	}

	// calculateAndDisplayRoute = (wdOneWay, directionsService, directionsRenderer, directionsRendererBackOW, locAddress, map) => {
	// 	if (locAddress.length === 1) {
	// 		// Remove backward way line in current map
	// 		directionsRendererBackOW.setMap(null)
	// 		// Write forward way line in current map

	// 		var waypts = [];
	// 		for (let i = 1; i < locAddress.length - 1; i++) {
	// 			waypts.push({
	// 				location: locAddress[i],
	// 				// stopover: true
	// 			});
	// 		}

	// 		directionsService.route({
	// 			origin: locAddress[0],
	// 			destination: locAddress[locAddress.length - 1],
	// 			waypoints: waypts,
	// 			// optimizeWaypoints: true,
	// 			travelMode: 'DRIVING'
	// 		}, (response, status) => {
	// 				if (status === 'OK') {

	// 					directionsRenderer.setOptions({ preserveViewport: true })
	// 					directionsRenderer.setDirections(response);

	// 					map.setZoom(15)
	// 					map.setCenter({lat: locAddress[0].lat, lng: locAddress[0].lng})

	// 					var _legs = response.routes[0].legs;
	// 					this.pA = this.createMarker(_legs[0].start_location, map, 0);
	// 			}
	// 		})
	// 	}
	// 	if (locAddress.length > 1 && !wdOneWay) { // 2 way
	// 		// Write backward way line in current map
	// 		directionsService.route({
	// 			origin: locAddress[locAddress.length - 1],
	// 			destination: locAddress[0],
	// 			waypoints: [],
	// 			// optimizeWaypoints: true,
	// 			travelMode: 'DRIVING'
	// 		}, (responseBackOW, status) => {
	// 			if (status === 'OK') {
	// 				directionsRendererBackOW.setMap(map);
	// 				directionsRendererBackOW.setDirections(responseBackOW);
	// 				// Write forward way line in current map (Put in here to make order of lines)

	// 				var waypts = [];
	// 				for (let i = 1; i < locAddress.length - 1; i++) {
	// 					waypts.push({
	// 						location: locAddress[i],
	// 						// stopover: true
	// 					});
	// 				}

	// 				directionsService.route({
	// 					origin: locAddress[0],
	// 					destination: locAddress[locAddress.length - 1],
	// 					waypoints: waypts,
	// 					// optimizeWaypoints: true,
	// 					travelMode: 'DRIVING'
	// 				}, (response, status) => {
	// 					if (status === 'OK') {

	// 						directionsRenderer.setDirections(response);

	// 						var _legs = response.routes[0].legs;
	// 						for (let i = 0; i < _legs.length; i++) {
	// 							if (i == 0) {
	// 								if (_legs[i].start_address === _legs[i].end_address) {
	// 									this.pA = this.createMarker(_legs[i].start_location, map, i);
	// 								} else {
	// 									this.pA = this.createMarker(_legs[i].start_location, map, i);
	// 									this.pEnd = this.createMarker(_legs[i].end_location, map, _legs.length);
	// 								}
	// 							} else {
	// 								this.pA += this.createMarker(_legs[i].start_location, map, i);
	// 								this.pEnd = this.createMarker(_legs[_legs.length - 1].end_location, map, _legs.length)
	// 							}
	// 						}
	// 					}
	// 				})
	// 			}
	// 		})

	// 	} else {
	// 		// Remove backward way line in current map
	// 		directionsRendererBackOW.setMap(null)
	// 		// Write forward way line in current map

	// 		var waypts = [];
	// 		for (let i = 1; i < locAddress.length - 1; i++) {
	// 			waypts.push({
	// 				location: locAddress[i],
	// 				// stopover: true
	// 			});
	// 		}

	// 		directionsService.route({
	// 			origin: locAddress[0],
	// 			destination: locAddress[locAddress.length - 1],
	// 			waypoints: waypts,
	// 			// optimizeWaypoints: true,
	// 			travelMode: 'DRIVING'
	// 		}, (response, status) => {
	// 			if (status === 'OK') {

	// 				directionsRenderer.setDirections(response);

	// 				var _legs = response.routes[0].legs;
	// 				for (let i = 0; i < _legs.length; i++) {
	// 					if (i == 0) {
	// 						if (_legs[i].start_address === _legs[i].end_address) {
	// 							this.pA = this.createMarker(_legs[i].start_location, map, i);
	// 						} else {
	// 							this.pA = this.createMarker(_legs[i].start_location, map, i);
	// 							this.pEnd = this.createMarker(_legs[i].end_location, map, _legs.length);
	// 						}
	// 					} else {
	// 						this.pA += this.createMarker(_legs[i].start_location, map, i);
	// 						this.pEnd = this.createMarker(_legs[_legs.length - 1].end_location, map, _legs.length)
	// 					}

	// 				}
	// 			}
	// 		})

	// 	}

	// }

	// getMarkerImage = (index) => {
	// 	var pins = [marker_0, marker_1, marker_2, marker_3, marker_4]
	// 	var icon = {
	// 		url: pins[index],
	// 		size: new window.google.maps.Size(40, 50),
	// 		origin: new window.google.maps.Point(0, 0),
	// 		anchor: new window.google.maps.Point(17, 34),
	// 		scaledSize: new window.google.maps.Size(34, 44)
	// 	};
	// 	return icon
	// }

	// createMarker = (latlng, map, index) => {
	// 	var markerArr = this.state.markerArr
	// 	var marker = new window.google.maps.Marker({
	// 		position: latlng,
	// 		map: map,
	// 		icon: this.getMarkerImage(index),
	// 		title: this.state.trip.wd.routing.routes[index].addr
	// 	});
	// 	var contentString = `<div>${this.state.trip.wd.routing.routes[index].addr}</div>`;
	// 	var infowindow = new window.google.maps.InfoWindow({
	// 		content: contentString
	// 	});
	// 	marker.addListener('click', function () {
	// 		infowindow.open(map, marker);
	// 	});
	// 	markerArr.push(marker)
	// 	this.setState({
	// 		markerArr: markerArr
	// 	})
	// 	return marker
	// }

	showGPSMap = () => {
		this.setState({
			showGPSMap: true,
		});
	};

	closeGPSMap = () => {
		this.setState({
			showGPSMap: false,
		});
	};

	showDriverLicense = () => {
		this.setState({
			showDriverLicense: true,
		});
	};

	closeDriverLicense = () => {
		this.setState({
			showDriverLicense: false,
		});
	};

	onProfileUrl = (owner) => {
		let state;
		if (owner) {
			state = {
				isOwner: false,
				isTrip: true,
				isReview: false,
			};
		} else {
			state = {
				isOwner: true,
				isTrip: true,
				isReview: false,
			};
		}
		// window.history.pushState(state, '', `/profile/${uid}`)
		localStorage.setItem("info", JSON.stringify(state));
	};

	render() {
		var content;
		var contentCertIns;
		if (this.state.err === commonErr.INNIT || this.state.err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (this.state.err >= commonErr.SUCCESS) {
			const {
				car,
				trip,
				certInfo,
				phoneInsMic,
				phoneInsPjico,
				phoneInsPVI,
				phoneInsVNI,
				cancelPolicy,
				specialDays,
				countdown,
			} = this.state;
			//cancelPolicy case
			// const cancelPolicyCase1 = trip.status === 4 && cancelPolicy === 1
			// const cancelPolicyCase2 = trip.status === 4 && cancelPolicy === 2
			// const cancelPolicyCase3 = trip.status === 4 && cancelPolicy === 3

			const specialDayStart = specialDays.filter((item) => moment(item.day).isSame(moment(trip.tripDateFrom), "day"));
			const specialDayEnd = specialDays.filter((item) => moment(item.day).isSame(moment(trip.tripDateTo), "day"));
			const specialDayStartText = specialDayStart.length > 0 ? specialDayStart[0].name : undefined;
			const specialDayEndText = specialDayEnd.length > 0 ? specialDayEnd[0].name : undefined;

			const isSD = trip.serviceType === 1;
			const priceSummary = isSD ? trip.priceSummary : trip.wd && trip.wd.priceSummary ? trip.wd.priceSummary : {};

			var loginId = this.props.session.profile.info.uid;
			var isOwner = loginId === trip.ownerId;

			var profile;

			for (var i = 0; i < this.state.profiles.length; ++i) {
				if (isOwner) {
					if (this.state.profiles[i].uid === trip.travelerId) {
						profile = this.state.profiles[i];
					}
				} else {
					if (this.state.profiles[i].uid === trip.ownerId) {
						profile = this.state.profiles[i];
					}
				}
			}
			if (car && trip && profile) {
				var footer;
				if (isOwner) {
					if (trip.status <= 1) {
						footer = (
							<div className="wrap-btn has-2-btn">
								<a className="btn btn--m btn-primary" onClick={this.showApproveForm}>
									Đồng ý yêu cầu
								</a>
								<a className="btn btn--m btn-secondary" onClick={this.showRejectForm}>
									Từ chối yêu cầu
								</a>
								<ApproveTripOwner
									getTrip={this.getTrip}
									trip={trip}
									show={this.state.showApproveForm}
									hideModal={this.closeApproveForm}
									car={car}
								/>
								<RejectTripOwner
									getTrip={this.getTrip}
									trip={trip}
									show={this.state.showRejectForm}
									hideModal={this.closeRejectForm}
								/>
							</div>
						);
					} else if (trip.status < 20) {
						if (trip.status === 4) {
							footer = (
								<div className="wrap-btn has-2-btn">
									<a className="btn btn--m btn-primary" onClick={this.showPickupForm}>
										Xác nhận {isSD ? "giao xe" : "đón khách"}
									</a>
									<a className="btn btn--m btn-secondary" onClick={this.showCancelOwnerForm}>
										Hủy chuyến
									</a>
									<PickupTrip
										getTrip={this.getTrip}
										trip={trip}
										show={this.state.showPickupForm}
										hideModal={this.closePickupForm}
									/>
									<CancelTripOwner
										getTrip={this.getTrip}
										trip={trip}
										show={this.state.showCancelOwnerForm}
										hideModal={this.closeCancelOwnerForm}
									/>
								</div>
							);
						} else if (trip.status === 5) {
							footer = (
								<div className="wrap-btn">
									<a className="btn btn--m btn-primary" onClick={this.showReturnForm}>
										Xác nhận {isSD ? "khách trả xe" : "bạn đã trả khách"}
									</a>
									<ReturnTrip
										getTrip={this.getTrip}
										trip={trip}
										step={0}
										show={this.state.showReturnForm}
										hideModal={this.closeReturnForm}
									/>
								</div>
							);
						} else {
							footer = (
								<div className="wrap-btn">
									<a className="btn btn--m btn-secondary" onClick={this.showCancelOwnerForm}>
										Hủy chuyến
									</a>
									<CancelTripOwner
										getTrip={this.getTrip}
										trip={trip}
										show={this.state.showCancelOwnerForm}
										hideModal={this.closeCancelOwnerForm}
									/>
								</div>
							);
						}
					} else if (trip.status === 25 && trip.needReview === 1) {
						footer = (
							<div className="wrap-btn">
								<a className="btn btn--m btn-primary" onClick={this.showReturnForm}>
									Đánh giá chuyến
								</a>
								<ReturnTrip
									getTrip={this.getTrip}
									trip={trip}
									step={2}
									show={this.state.showReturnForm}
									hideModal={this.closeReturnForm}
								/>
							</div>
						);
					}
				} else {
					if (trip.status <= 1) {
						footer = (
							<div className="wrap-btn">
								<a className="btn btn--m btn-secondary" onClick={this.cancelTrip}>
									Hủy chuyến
								</a>
								<CancelTrip
									getTrip={this.getTrip}
									trip={trip}
									show={this.state.showCancelForm}
									hideModal={this.closeCancelForm}
								/>
							</div>
						);
					} else if (trip.status <= 3) {
						footer = (
							<div className="wrap-btn has-2-btn">
								<a
									className="btn btn--m btn-primary"
									href={`/payment/${trip.id}?deposit=${trip.priceSummary.deposit}&timeExpired=${trip.timeExpired}`}>
									Đặt cọc
								</a>
								<a className="btn btn--m btn-secondary" onClick={this.cancelTrip}>
									Hủy chuyến
								</a>

								<CancelTrip
									getTrip={this.getTrip}
									trip={trip}
									show={this.state.showCancelForm}
									hideModal={this.closeCancelForm}
								/>
							</div>
						);
					} else if (trip.status < 5) {
						footer = (
							<div className="wrap-btn">
								<a className="btn btn--m btn-secondary" onClick={this.cancelTrip}>
									Hủy chuyến
								</a>
								<CancelTrip
									getTrip={this.getTrip}
									trip={trip}
									show={this.state.showCancelForm}
									hideModal={this.closeCancelForm}
								/>
							</div>
						);
					} else if (trip.needReview === 1) {
						footer = (
							<div className="wrap-btn">
								<a className="btn btn--m btn-primary" onClick={this.travelerReview}>
									Đánh giá chuyến
								</a>

								<ReviewTripTraveler
									getTrip={this.getTrip}
									trip={trip}
									show={this.state.isShowTravelerReviewForm}
									hideModal={this.closeTravelerReviewForm}
								/>
							</div>
						);
					}
				}
				if (trip.insSupport === 1 && trip.insActiveInfo) {
					let phonesIns =
						trip.insActiveInfo.activeBy === 1
							? phoneInsMic
							: trip.insActiveInfo.activeBy === 3
							? phoneInsPVI
							: phoneInsVNI;

					if (trip.insActiveInfo.activeBy === 3) {
						contentCertIns = (
							<div className="modal-text-body modal-ins-cardetail-body modal-ins-tripdetail-body">
								<div className="ins-cardetail-inner">
									<img loading="lazy" className="main-img" src={bg_ins} />
									<h5>Chi tiết bảo&nbsp;hiểm</h5>
									<div className="ins-cardetail-child">
										<h6>Chứng nhận bảo hiểm</h6>
										<div className="img-gr">
											<div className="img-gr-item">
												<p>Đơn vị bảo hiểm</p>
												<img loading="lazy" src={pvi} />
											</div>
											<div className="img-gr-item">
												<p>Phân phối bởi</p>
												<img loading="lazy" src={global_care} />
											</div>
										</div>
									</div>
								</div>
								<b>Số: {trip.insActiveInfo.certNo}</b>
								<div className="block-content">
									<p className="body-title">Thông tin yêu cầu bảo hiểm</p>
									<div className="gr-item">
										<p>Loại xe: </p>
										<span>{car.name}</span>
									</div>
									<div className="gr-item">
										<p>Biển số xe: </p>
										<span>{car.licensePlate}</span>
									</div>
								</div>
								<div className="hotline">
									<p>Hotline toàn quốc</p>
									{phonesIns && phonesIns.map((phone) => <span>{phone.contacts[0].phone}</span>)}
								</div>
								<div className="full-line" />
								<div className="block-content">
									<p className="body-title">Các phạm vi bảo hiểm chính</p>
									<ul className="disc-ul">
										<li>Bảo hiểm con người: tối đa 200 triệu/người/vụ</li>
										<p className="note font-14">* Phí y tế điều trị nội trú: 200k/ngày, tối đa 180 ngày/năm</p>
										<li>Bảo hiểm TNDS về người và tài sản với bên thứ 3: tối đa 300 triệu/vụ</li>
									</ul>
								</div>
								<div className="block-content">
									<p className="body-title">Khi xảy ra sự cố, vui lòng</p>
									<p className="fontWeight-6">TH không có va chạm bên thứ 3:</p>
									<ul className="number-ul">
										<li>Sơ cứu người bị thương hoặc gọi cấp cứu 115.</li>
										<li>Chụp ảnh hiện trường.</li>
										<li>Thông báo cho Bảo hiểm PVI theo số 1900 54 54 58 &amp; làm theo hướng dẫn tổng đài.</li>
										<li>
											Nộp hồ sơ yêu cầu bồi thường, gồm:
											<ul className="disc-ul">
												<li>Bản sao giấy tờ xe (cavet, đăng kiểm, bằng lái xe);</li>
												<li>Đơn yêu cầu bồi thường (theo mẫu của PVI);</li>
												<li>Hồ sơ điều trị &amp; chứng từ thanh toán.</li>
											</ul>
										</li>
									</ul>
									<p className="fontWeight-6">TH có va chạm bên thứ 3:</p>
									<ul className="number-ul">
										<li>Sơ cứu người bị thương hoặc gọi cấp cứu 115.</li>
										<li>Chụp ảnh hiện trường &amp; thông báo đến cơ quan CA gần nhất.</li>
										<li>Thông báo cho Bảo hiểm PVI theo số 1900 54 54 58 &amp; làm theo hướng dẫn tổng đài.</li>
										<li>
											Nộp hồ sơ yêu cầu bồi thường, gồm:
											<ul className="disc-ul">
												<li>Bản sao giấy tờ xe (cavet, đăng kiểm, bằng lái xe);</li>
												<li>Đơn yêu cầu bồi thường (theo mẫu của PVI);</li>
												<li>Hồ sơ TNGT của Cơ quan CA (nếu sự cố có thiệt hại ước tính &gt;10tr);</li>
												<li>Hồ sơ điều trị &amp; chứng từ thanh toán.</li>
											</ul>
										</li>
									</ul>
								</div>
								<div className="block-content">
									<p className="body-title">Thời hạn bảo hiểm</p>
									<p>
										Từ {moment(trip.insActiveInfo.timeActived).format("DD/MM/YYYY HH:mm")} - Đến{" "}
										{moment(trip.insActiveInfo.timeEnd).format("DD/MM/YYYY HH:mm")}
									</p>
									<p>Chương trình bảo hiểm này là sản phẩm bảo hiểm của PVI được phân phối tại Global Care</p>
								</div>
								<div className="wrap-btn">
									<a className="btn btn--m btn-primary" onClick={() => this.onCertDetailBtn(trip.insActiveInfo)}>
										Tải giấy chứng nhận
									</a>
								</div>
							</div>
						);
					} else {
						contentCertIns = (
							<div className="modal-text-body modal-ins-cardetail-body modal-ins-tripdetail-body">
								<div className="ins-cardetail-inner">
									<img loading="lazy" className="main-img" src={bg_ins} />
									<h5>Chi tiết bảo&nbsp;hiểm</h5>
									<div className="ins-cardetail-child">
										<h6>Chứng nhận bảo hiểm</h6>
										<div className="img-gr">
											<div className="img-gr-item">
												<p>Đơn vị bảo hiểm</p>
												<img loading="lazy" src={trip.insActiveInfo.activeBy === 1 ? mic : vni} />
											</div>
											<div className="img-gr-item">
												<p>Phân phối bởi</p>
												<img loading="lazy" src={global_care} />
											</div>
										</div>
									</div>
								</div>
								<b>Số: {trip.insActiveInfo.certNo}</b>
								<div className="block-content">
									<p className="body-title">Thông tin yêu cầu bảo hiểm</p>
									<div className="gr-item">
										<p>Loại xe: </p>
										<span>{car.name}</span>
									</div>
									<div className="gr-item">
										<p>Biển số xe: </p>
										<span>{car.licensePlate}</span>
									</div>
								</div>
								<div className="hotline">
									<p>Hotline toàn quốc</p>
									{phonesIns && phonesIns.map((phone) => <span>{phone.contacts[0].phone}</span>)}
									{/* 
							<span>{trip.insActiveInfo.activeBy === 1 ? phonesInsPVI[0].contacts[0].phone : phoneInsPjico[0].contacts[0].phone}</span>
						*/}
								</div>
								<div className="full-line" />
								<div className="block-content">
									<p className="body-title">Các phạm vi bảo hiểm chính</p>
									<ul className="disc-ul">
										<li>Bảo hiểm vật chất xe: đâm va , hỏa hoạn, cháy nổ</li>
										<li>Miễn phí cứu hộ tối đa 70km/vụ</li>
										<li>Bảo hiểm thủy kích (khấu trừ 20% số tiền bảo hiểm, tối thiểu 3 triệu đồng)</li>
										{trip.insActiveInfo.activeBy === 5 && (
											<li>Bảo hiểm mất cắp bộ phận (khấu trừ 20% số tiền bảo hiểm, tối thiểu 5 triệu đồng)</li>
										)}
										<li>Mức khấu trừ: 2,000,000đ/vụ</li>
									</ul>
								</div>
								<p className="font-14 note">
									• Giải thích <strong>Mức khấu trừ</strong>: mọi sự cố ngoài ý muốn trong phạm vi bảo hiểm, số tiền tối
									đa khách thuê thanh toán là <u>2&nbsp;triệu&nbsp;đồng</u>, chưa bao gồm:
								</p>
								<p className="font-14 note">- Giảm trừ bồi thường/chế tài theo Quy tắc của Nhà bảo hiểm,</p>
								<p className="font-14 note">- Thiệt hại do xe không cho thuê được trong thời gian sửa chữa nếu có,</p>
								<p className="font-14 note">- Các lí do chủ quan khác nằm ngoài phạm vi bảo hiểm.</p>
								<p className="font-14 note">
									<i>
										Quy tắc bảo hiểm {trip.insActiveInfo.activeBy === 1 ? "MIC" : "VNI"}: Xem thêm tại
										<a
											className="font-14 note fontWeight-8"
											href={
												trip.insActiveInfo.activeBy === 1
													? "https://n1-cstg.mioto.vn/m/insurance/Quy-tac-MIC.pdf"
													: "https://n1-cstg.mioto.vn/m/insurance/Quy-tac-VNI.pdf"
											}
											target="_blank">
											{" "}
											<u>liên kết</u>
										</a>
									</i>
								</p>
								<div className="block-content">
									<p className="body-title">Khi xảy ra sự cố, vui lòng</p>
									<ul className="number-ul">
										<li>
											Khách thuê
											<span className="text-danger"> giữ nguyên hiện trường & chụp ảnh xe đang bị sự cố.</span>
										</li>
										<li>
											Khách thuê gọi đến trung tâm bồi thường của nhà bảo hiểm{" "}
											<span className="text-danger fontWeight-8">tại thời điểm xảy ra sự cố </span>
											<span className="fontWeight-8">
												({trip.insActiveInfo.activeBy === 1 ? "MIC" : "VNI"} -{" "}
												{phonesIns && phonesIns.length > 0 && phonesIns[0].contacts[0].phone})
											</span>
											, đọc số hợp đồng bảo hiểm và làm theo hướng dẫn tổng đài.
										</li>
										<li>
											Giám định viên bảo hiểm liên hệ khách thuê để hướng dẫn xử lí, xác minh thông tin và xác minh hiện
											trường (nếu có).
										</li>
										<li>
											Giám định viên và chủ xe/khách thuê cùng mang xe ra Garage để giám định thiệt hại và ra
											<span> Báo giá sửa chữa.</span>
										</li>
										<li>
											Trung tâm bồi thường của nhà bảo hiểm ra <span>Biên bản giám định thiệt hại.</span>
										</li>
										<li>Garage tiến hành sửa chữa theo báo giá.</li>
									</ul>
								</div>
								<div className="block-content">
									<p className="body-title">Thời hạn bảo hiểm</p>
									<p>
										Từ {moment(trip.insActiveInfo.timeActived).format("DD/MM/YYYY HH:mm")} - Đến{" "}
										{moment(trip.insActiveInfo.timeEnd).format("DD/MM/YYYY HH:mm")}
									</p>
									<p>
										Chương trình bảo hiểm này là sản phẩm bảo hiểm của{" "}
										{trip.insActiveInfo.activeBy === 1 ? "MIC" : "VNI"} được phân phối tại Global Care
									</p>
								</div>
								<div className="wrap-btn">
									<a className="btn btn--m btn-primary" onClick={() => this.onCertDetailBtn(trip.insActiveInfo)}>
										Tải giấy chứng nhận
									</a>
								</div>
							</div>
						);
					}
				}

				const timeEnabledUpload = convertToDateTimeObj(trip.insUpThr);

				var subContent = (
					<section className="body">
						<div className="trip-detail-module">
							<StatusTrip trip={trip} countdown={countdown} isOwner={isOwner} />
							<div className="trip-detail-container">
								<div className="m-container">
									<div className="content-trip">
										<a
											className="info-car"
											href={`/car/${isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`}
											target="_blank">
											<div className="img-car">
												<img
													loading="lazy"
													src={car.photos ? car.photos[0].thumbUrl : ""}
													alt={`Cho thuê xe tự lái ${car.name}`}
												/>
											</div>
											<div className="info-desc-car">
												<p className="name">
													{car.name}
													<span className="dot">• </span>
													<span className="car-mode">{isSD ? "Xe tự lái" : "Xe có tài xế"}</span>
												</p>
												<div className="group-tag">
													{trip.b2b && <span className="tag-item transmission">Doanh nghiệp</span>}
													<span className={`tag-item ${car.optionsTransmission === 1 ? "transmission" : "delivery"}`}>
														{CarTransmission[car.optionsTransmission]}
													</span>

													{/* <span className="tag-item non-mortgage">Giao xe sân bay <span className="dot">• </span>140K</span> */}
												</div>
												<div className="address">
													<div className="wrap-svg">
														<IcLocationS />
													</div>
													<p>{car.locationAddr}</p>
												</div>
											</div>
										</a>
										<div className="line-page" />

										<div className="desc-car">
											<h6>Thời gian thuê xe</h6>
											<div className="rental-time">
												<div className="rental-time__item">
													<div className="wrap-svg">
														<IcCalendarBlack />
													</div>
													<div className="title">
														<p className="sub">Bắt đầu thuê xe</p>
														<h6 className="main">{moment(trip.tripDateFrom).format(" HH:mm - DD/MM/YYYY")}</h6>
														{specialDayStartText && <p className="label">{specialDayStartText}</p>}
													</div>
												</div>
												<div className="rental-time__item">
													<div className="wrap-svg">
														<IcCalendarBlack />
													</div>
													<div className="title">
														<p className="sub">Kết thúc thuê xe</p>
														<h6 className="main">{moment(trip.tripDateTo).format("HH:mm - DD/MM/YYYY")}</h6>
														{specialDayEndText && <p className="label">{specialDayEndText}</p>}
													</div>
												</div>
												{/* {isSD && <div className="rental-time__item"> 
									<div className="wrap-svg">
										<IcLimitKM />
									</div>
									<div className="title"> 
										<p className="sub">Giới hạn số km</p>
										{car.limitEnable > 0 ? 
										<>
											<h6 className="main">{car.limitKM} km/ngày.</h6>
											<p className="sub font-12">Phí {formatPrice(car.limitPrice)} /km vượt giới hạn</p>
										</>:
										<h6 className="main">Không giới hạn</h6> }
									</div>
								</div>} */}
											</div>
										</div>
									</div>

									<div className="sidebar-trip">
										<InsuranceTrip trip={trip} showInsuranceForm={this.showInsuranceForm} />
										{trip.status === 4 && !isOwner && <BeforeTrip />}
										<div className="rent-box">
											<a
												className="profile"
												onClick={() => this.onProfileUrl(isOwner)}
												href={`/profile/${profile.uid}`}>
												<div className="avatar avatar--l">
													<img
														loading="lazy"
														src={profile.avatar && profile.avatar.thumbUrl ? profile.avatar.thumbUrl : avatar_default}
													/>
												</div>
												<div className="info">
													<p className="tag">
														{!trip.b2b && isOwner ? "Khách thuê" : trip.b2b && isOwner ? "Doanh nghiệp" : "Chủ xe"}
													</p>
													<h6>{profile.name}</h6>
													{isOwner ? (
														profile.traveler.totalTrips > 0 ? (
															<div className="group" style={{ alignItems: "center" }}>
																<div className="wrap-svg">
																	<IcStarRating />
																</div>
																<p>{profile.traveler.rating.avg.toFixed(1)}</p>
																<span className="dot">•</span>
																<div className="wrap-svg">
																	<IcTotalTrip />
																</div>
																<p>{renderNumberGreaterThan100(profile.traveler.totalTrips)} chuyến</p>
															</div>
														) : (
															<div className="group">
																<p>Chưa có đánh giá</p>
															</div>
														)
													) : profile.owner.totalTrips > 0 ? (
														<div className="group" style={{ alignItems: "center" }}>
															<div className="wrap-svg">
																<IcStarRating />
															</div>
															<p> {profile.owner.rating.avg.toFixed(1)}</p>
															<span className="dot">•</span>
															<div className="wrap-svg">
																<IcTotalTrip />
															</div>
															<p>{profile.owner.totalTrips} chuyến</p>
														</div>
													) : (
														<div className="group">
															<p>Chưa có đánh giá</p>
														</div>
													)}
												</div>
												{isSD && isOwner && trip.travellerDriverLicense && (
													<p className="font-13 text-link" onClick={this.showDriverLicense}>
														Xem giấy tờ khách thuê
													</p>
												)}
											</a>
											{trip.status < 6 && (
												<div className="phone">
													{trip.status < 6 && trip.status > 3 && (
														<div className="number-phone">
															<div className="wrap-svg">
																<IcPhone />
															</div>
															<div className="title">
																<p className="sub">Số điện thoại </p>
																{isOwner ? (
																	<p className="main">{trip.travelerPhoneNumber || "***********"}</p>
																) : (
																	<p className="main">{trip.ownerPhoneNumber || "***********"}</p>
																)}
															</div>
														</div>
													)}
													{trip.status < 4 && (
														<div className="note-warning">
															<div className="wrap-svg">
																<IcInformation />
															</div>
															{isOwner ? (
																<p>Thông tin liên hệ với khách thuê sẽ được hiển thị sau khi đặt cọc</p>
															) : (
																<p>Thông tin liên hệ với chủ xe sẽ được hiển thị sau khi đặt cọc</p>
															)}
														</div>
													)}
												</div>
											)}
											<div className="line-page" />
											{isSD && (
												<div className="address-deli">
													<p className="title">Địa điểm giao xe</p>
													<div className="address">
														<div className="wrap-svg">
															<IcLocationGreen />
														</div>
														<p>{trip.dAddr === car.locationAddr ? car.locationAddr : trip.dAddr}</p>
													</div>
													{trip.dAddr === car.locationAddr && trip.status < 4 && (
														<p className="font-12 sub"> Địa chỉ cụ thể sẽ được hiển thị sau khi đặt cọc</p>
													)}
												</div>
											)}

											{!isSD && (
												<>
													<div className="map-route">
														<div ref={this.map} id="map" className="wrap-map"></div>
													</div>
													<div className="address-deli">
														<p className="title">
															Lộ trình:{" "}
															{trip.wd.wdType === wdType.WDT_CITY_TOUR
																? "Nội thành"
																: trip.wd.wdType === wdType.WDT_ONEWAY
																? "Liên tỉnh - 1 chiều"
																: "Liên tỉnh - 2 chiều"}
														</p>
														<div className="address">
															<div className="wrap-svg">
																{trip.wd.wdType === wdType.WDT_CITY_TOUR ? <IcLocationGreen /> : <IcStartLocGreen />}
															</div>
															<p>{trip.wd.routing.routes[0].addr}</p>
														</div>
														{trip.wd.routing.routes.map((address, index) => {
															if (index === 0) return null;
															return (
																<div className="address">
																	<div className="wrap-svg">
																		<IcEndLocGreen />
																	</div>
																	<p>{address.addr}</p>
																</div>
															);
														})}
													</div>
													<div className="route">
														<p className="title">Thông tin lộ trình</p>
														{trip.wd.priceSummary && trip.wd.priceSummary.distanceInKM > 0 && (
															<div className="route__item">
																<p>Tổng lộ trình</p>
																<p className="cost">{trip.wd.priceSummary.distanceInKM.toFixed(1)} km </p>
															</div>
														)}
														{trip.wd.priceSummary && trip.wd.priceSummary.limitKM > 0 && (
															<div className="route__item">
																<p>Số km được đi</p>
																<p className="cost">{trip.wd.priceSummary.limitKM} km</p>
															</div>
														)}
														{trip.wd.priceSummary && trip.wd.priceSummary.limitKM > 0 && (
															<div className="route__item">
																<p>Phí phụ thu vượt {trip.wd.priceSummary && trip.wd.priceSummary.limitKM} km</p>
																<p className="cost">{formatPrice(trip.wd.priceSummary.extraKMFee)} /km</p>
															</div>
														)}
														<div className="route__item">
															<p>Phí phụ thu vượt {trip.wd.priceSummary && trip.wd.priceSummary.totalHours} giờ</p>
															<p className="cost">{formatPrice(trip.wd.priceSummary.extraHourFee)} /giờ</p>
														</div>
													</div>
													{car.wdShort && (
														<div className="route">
															<p className="title">Thông tin đưa đón</p>
															{car.wdShort.deliveryRadius > 0 && (
																<div className="route__item">
																	<p>Hỗ trợ đưa đón</p>
																	<p className="cost">trong vòng {car.wdShort.deliveryRadius} km </p>
																</div>
															)}
															{car.wdShort.deliveryPrice > 0 && (
																<div className="route__item">
																	<p>Phí đưa đón</p>
																	<p className="cost">{formatPrice(car.wdShort.deliveryPrice)} /km</p>
																</div>
															)}
															{car.wdShort.deliveryRadiusFree > 0 && (
																<div className="route__item">
																	<p>Miễn phí đưa đón trong vòng</p>
																	<p className="cost">{car.wdShort.deliveryRadiusFree} km</p>
																</div>
															)}
														</div>
													)}
												</>
											)}
											<div className="line-page" />
											<PriceSummary
												priceSummary={priceSummary}
												title="Bảng tính giá"
												isSD={isSD}
												trip={true}
												promo={trip.promo}
											/>
											<div className="line-page" />
											<div className="message">
												<p className="title">Lời nhắn riêng: </p>
												{trip.messageFromTraveller && trip.messageFromTraveller !== "" ? (
													<pre>{trip.messageFromTraveller}</pre>
												) : (
													<span>Không có lời nhắn</span>
												)}
											</div>
											{footer}
										</div>
										{isSD && <Surcharge info={car} tripD={true} trip={trip} />}
									</div>
									<div className="content-trip">
										{isSD && <Papers info={car} trip={true} />}
										{isSD && <Mortgates info={car} trip={true} />}
										<Policy trip={true} policies={isSD ? car.notes : car.wdFull && car.wdFull.policies} />
										<CancelPolicy />
									</div>

									{/* {trip.insSupport === 1 && trip.insPhotos && (trip.status < 20 || trip.status >= 25) && <div className="group-tphoto">
												<div className="group-info">
													<h6>Bảo hiểm bởi MIC</h6>
												
													{((trip.status >= 4 && trip.status < 20) || trip.status >= 25) && this.isEnabledActIns() && <TripPhotoSlider
														trip={trip}
														showTripPhoto={this.showTripPhoto}
														showMessageUpload={this.showMessageUpload}
														frInsPhoto={this.state.frInsPhoto}
														baInsPhoto={this.state.baInsPhoto}
														leInsPhoto={this.state.leInsPhoto}
														riInsPhoto={this.state.riInsPhoto} />}
										
													{trip.insReady === 0 && trip.insActiveInfo === null && trip.status < 4 && <div className="ins-notice">
														<p className="note text-danger">Bạn cần đặt cọc để kích hoạt bảo hiểm</p> 
													</div>}

													{(trip.status < 5 && trip.status >= 4) && trip.insReady === 0 && trip.insActiveInfo === null && !this.isEnabledActIns() && <div className="ins-notice" >
													<p className="note text-danger"> Gói bảo hiểm có thể kích hoạt trước chuyến đi     {timeEnabledUpload.days > 0 ? `${timeEnabledUpload.days} ngày` : `${timeEnabledUpload.hours} tiếng`}</p></div>}
						
													{((trip.status >= 4 && trip.status < 20) || trip.status >= 25) && trip.insReady === 0 && trip.insActiveInfo === null && this.isEnabledActIns() && <div className="ins-notice" >
														<p className="note text-danger">Cung cấp thêm hình ảnh để kích hoạt gói Bảo hiểm</p>
														<a onClick={this.showTripPhoto} className="btn btn--s btn-primary" href="#!"><span>Thêm hình</span></a></div>}
									
													{((trip.status >= 4 && trip.status < 20) || trip.status >= 25) && trip.insReady === 1 && trip.insActiveInfo === null && <div className="ins-notice" style={{justifyContent: "flex-end"}}>
													<a onClick={this.activeInsurance} className="btn btn--s btn-default" href="#!"><i className="ic ic-retry-insurance"></i><span>Kích hoạt ngay</span></a></div>}
							
										
													<MessageBox show={this.state.errMsg !== ""} error={this.state.actErr} message={this.state.errMsg} hideModal={this.hideMessageBox} /> 
													</div>
											</div>} */}
								</div>

								<Login
									show={this.state.showLoginForm}
									openSignupForm={this.openSignupForm}
									showModal={this.openLoginForm}
									hideModal={this.closeLoginForm}
									getLoggedProfile={this.getLoggedProfile}
								/>
								<SignUp
									show={this.state.showSignup}
									showModal={this.openSignupForm}
									hideModal={this.closeSignupForm}
									openLoginForm={this.openLoginForm}
									getLoggedProfile={this.getLoggedProfile}
								/>
								{/* <TripPhoto
								show={this.state.showTripPhoto}
								close={this.closeTripPhoto}
								trip={trip}
								frInsPhoto={this.state.frInsPhoto}
								baInsPhoto={this.state.baInsPhoto}
								leInsPhoto={this.state.leInsPhoto}
								riInsPhoto={this.state.riInsPhoto}
								handleFrInsInputChange={this.handleFrInsFileInputChange}
								handleBaInsInputChange={this.handleBaInsFileInputChange}
								handleLeInsInputChange={this.handleLeInsFileInputChange}
								handleRiInsInputChange={this.handleRiInsFileInputChange}
								removeInsPhoto={this.removeInsurancePhoto}
							/> */}
								{/* <Modal
							show={this.state.showMessageUpload}
							onHide={this.closeMessageUpload}
							dialogClassName="modal-sm modal-dialog"
						>
							<Modal.Header closeButton={true} closeLabel={""}>
								<h5>Thông báo</h5>
							</Modal.Header>
							<Modal.Body>
								<div className="form-default form-s">
									<div className="textAlign-center"><i className="ic ic-error" /> Bạn chỉ được phép đăng hình ảnh chuyến trước chuyến đi {timeEnabledUpload.days > 0 ? `${timeEnabledUpload.days} ngày` : `${timeEnabledUpload.hours} tiếng`}.</div>
								</div>
							</Modal.Body>
						</Modal> */}

								<Modal
									show={this.state.showInsuranceForm}
									onHide={this.closeInsuranceForm}
									dialogClassName="modal-l modal-dialog modal-text">
									<Modal.Header closeButton={true} closeLabel={""}></Modal.Header>
									<Modal.Body>
										{contentCertIns}
										{certInfo && (
											<MessageBox
												show={this.state.showMsgCert}
												error={this.state.certErr}
												message={certInfo.msg}
												hideModal={this.closeMsgCert}
											/>
										)}
									</Modal.Body>
								</Modal>
								{/* <Modal
							show={this.state.showGPSMap}
							onHide={this.closeGPSMap}
							dialogClassName="modal-l modal-ins-form modal-confirm"
						>
							<Modal.Header closeButton={true} closeLabel={""}>
								<h5>Bản đồ GPS</h5>

							</Modal.Header>
							<Modal.Body>
								<div className="module-register">
									<div className="register-container">
										<div className="content-register">
											<GPSMap tripId={trip.id} tripStatus={trip.status} carId={car.id} />
										</div>
									</div>
								</div>
							</Modal.Body>
						</Modal> */}
								{trip.travellerDriverLicense && (
									<DriverLicense
										show={this.state.showDriverLicense}
										hideModal={this.closeDriverLicense}
										data={trip.travellerDriverLicense}
									/>
								)}
							</div>
							<div className="clear" />
						</div>
					</section>
				);
				content = (
					<div className="mioto-layout">
						<Session />
						<Header />
						{subContent}
						<Footer />
					</div>
				);
			} else {
				content = <Redirect to="/notfound" />;
			}
		} else {
			content = <Redirect to="/notfound" />;
		}

		return content;
	}
}

function mapSession(state) {
	return {
		session: state.session,
	};
}

TripDetail = connect(mapSession)(TripDetail);

export default TripDetail;
